import { Link } from "@mui/material";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";

import StarringYouPresenter from "presenters/StarringYouPresenter";
import StarringYouClipPresenter from "presenters/StarringYouClipPresenter";
import ResponsiveImage from "components/ResponsiveImage";

import Details from "../Details";
import RankNumber from "../Styled/RankNumber";
import HoverOverlay from "../Styled/HoverOverlay";

const SlideContent = ({ item, index, isTopRanking = false, onClick, isMobile, desktopWidth, mobileWidth }) => {
  const rank = index + 1;
  const isClip = StarringYouPresenter.isStarringYouClip(item);
  const thumbnail = isClip ? StarringYouClipPresenter.previewPoster(item) : StarringYouPresenter.thumb(item);

  const handleClick = () => (onClick ? onClick(item) : null);

  return (
    <>
      {isTopRanking && <RankNumber hasTwoDigits={rank > 9}>{rank}</RankNumber>}
      <div>
        <Link to={StarringYouPresenter.handleRedirect(item)} component={NavLink} onClick={handleClick}>
          <HoverOverlay>
            <ResponsiveImage
              src={thumbnail}
              alt={StarringYouPresenter.name(item) || ""}
              width={desktopWidth}
              widthMobile={mobileWidth}
              isMobile={isMobile}
            />
          </HoverOverlay>
        </Link>
        <Details item={item} imageWidth={isMobile ? mobileWidth : desktopWidth} />
      </div>
    </>
  );
};

SlideContent.propTypes = {
  item: StarringYouPresenter.shape(),
  index: PropTypes.number.isRequired,
  isTopRanking: PropTypes.bool,
  onClick: PropTypes.func,
  isMobile: PropTypes.bool.isRequired,
  desktopWidth: PropTypes.number.isRequired,
  mobileWidth: PropTypes.number.isRequired,
};

export default SlideContent;
